module.exports = __webpack_public_path__ + "1c76c5f242ae6b985b8a7999aba2ee97.MP3";